import type { Theme } from '@mui/material';

export const styles = {
  tableWidget: () => ({}),

  tableHead: () => ({
    flexWrap: 'nowrap',

    '& > .MuiGrid-item': {
      display: 'flex',
      alignItems: 'center',
    },
  }),

  heading: (theme: Theme) => ({
    ...theme.typography.h3,
    fontWeight: theme.typography.fontWeightBold,
    display: 'flex',
  }),

  headingTopStatements: (theme: Theme) => ({
    color: theme.colors.generalVeryPositive,
  }),

  headingBottomStatements: (theme: Theme) => ({
    color: theme.colors.generalVeryNegative,
  }),

  headingIcon: () => ({
    fontSize: '1.05em',
    minWidth: '1.5em',
    marginTop: '0.15em',
    marginRight: '0.25em',
  }),

  tableBody: () => ({}),

  favDivLabelWrapper: (theme: Theme) => ({
    '&.MuiGrid-item': {
      [theme.breakpoints.up('md')]: {
        wordBreak: 'break-all',
        textAlign: 'center',
        alignItems: 'flex-start',
        justifyContent: 'center',
      },
    },

    '& > *.MuiTypography-root:not(.NumberDifference-root)': {
      display: 'block',
    },
  }),

  // Mimic headingIcon and rank element width to align content properly on smaller viewport.
  favDivLabelWrapperOffset: (theme: Theme) => ({
    '& > *.MuiTypography-root': {
      [theme.breakpoints.down('md')]: {
        marginLeft: '2.25em',
      },
    },
  }),

  rank: (theme: Theme) => ({
    ...theme.typography.h3,
    fontWeight: theme.typography.fontWeightBold,
    minWidth: '1.5em',
    marginRight: '0.35em',
    color: theme.colors.neutral[200],
  }),
};
